import React, { useState } from 'react';
import _ from 'lodash';
import { Spinner } from 'reactstrap';
import { useParams } from 'react-router-dom';
import { connect } from 'react-redux';
import Block from '../common/Display/Block';
import { t } from '../common/Translate';
import mapStateToProps from '../../Store/mapping/record/mapStateToProps';
import mapDispatchToProps from '../../Store/mapping/record/mapDispatchToProps';
import VersionsBloc from './views/VersionsBloc';
import NotificationsBloc from './views/NotificationsBloc';
import VehicleBloc from './views/VehicleBloc';

const Vincheck = (props) => {
  const { recordId } = useParams();
  const [vincheck] = useState(_.get(props, `reduxVincheck.data[${recordId}]`, null));
  const [isLoading] = useState(_.get(props, `reduxVincheck.loading`, null));
  // const [error, setError] = useState(_.get(props, `reduxVincheck.error`, null));

  return (
    <Block {...props} noBack>
      <h1 className="page-title">
        <span className="cursor-pointer">{t('VIN_page')}</span>
      </h1>

      <NotificationsBloc {...vincheck} />
      <VehicleBloc {...vincheck} />
      <VersionsBloc {...vincheck} />

      {isLoading && (
        <div className="loader-full-screen main">
          <Spinner />
        </div>
      )}
    </Block>
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(Vincheck);
